import * as React from 'react';
const SvgPowershell = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={48} height={48} {...props}>
    <path
      fill='#0277bd'
      d='M19.847 41.956c-5.629-.002-11.259.024-16.888-.013-2.855-.019-3.374-.7-2.731-3.525 2.178-9.58 4.427-19.143 6.557-28.734C7.356 7.112 8.588 5.975 11.312 6c11.258.106 22.517.034 33.776.046 2.824.003 3.298.614 2.664 3.511a5514 5514 0 0 1-6.236 28.203c-.789 3.516-1.697 4.187-5.353 4.195-5.439.011-10.878.003-16.316.001z'
    />
    <path
      fill='#fafafa'
      d='M25.057 23.922c-.608-.687-1.114-1.267-1.531-1.732-2.43-2.728-4.656-5.27-7.063-7.869-1.102-1.189-1.453-2.344-.13-3.518 1.307-1.16 2.592-1.058 3.791.277 3.34 3.717 6.676 7.438 10.071 11.104 1.268 1.369.972 2.3-.424 3.315a2137.388 2137.388 0 0 0-16.01 11.778c-1.196.887-2.337 1.109-3.304-.201-1.066-1.445-.08-2.305 1.026-3.114 3.955-2.893 7.903-5.798 11.834-8.725.548-.407 1.278-.97 1.74-1.315zM21.75 37C20.625 37 20 36 20 35s.625-2 1.75-2h9.5c1.125 0 1.75 1 1.75 2s-.625 2-1.75 2h-9.5z'
    />
  </svg>
);
export default SvgPowershell;
